import React from "react";
import {AppButton} from "../../../styles/Butttons";
import Modal from "../../../containers/Modal";
import {Input} from "../../../styles/Forms";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
// import {ReactComponent as CancelIcon} from "../../../assets/icons/cancel.svg";

export default function EditAdminModal({isOpen, close, theme, save, showSuccess, data}) {
   const SaveUser = e => {
      e.preventDefault();
      const formda = e.target;
      let newUser = {
         ...data,
         last_name: formda.name.value.split(" ")[1],
         name: formda.name.value,
         first_name: "sadsa",
         area: formda.area.value,
         email: formda.email.value,
         password: formda.password.value,
      };
      // console.log(newUser);
      save(newUser);
   };

   return (
      <Modal
         isOpen={isOpen}
         close={() => {
            close();
         }}
         confirm={true}
         theme={theme}
         showSuccess={showSuccess}
         title="Añadir administrador"
      >
         <DivModal>
            <form onSubmit={SaveUser}>
               <Grid>
                  <Col large="9">
                     <Input defaultValue={data.name} placeholder="Nombre" name="name" />
                  </Col>
                  {/* <Col large="4" /> */}
                  <Col large="5">
                     <Input defaultValue={data.area} placeholder="Area" name="area" />
                  </Col>
                  <Col large="2" />
                  <Col large="5">
                     <Input defaultValue={data.email} placeholder="E-Mail" name="email" />
                  </Col>
                  <Col large="5">
                     <Input defaultValue={data.password} placeholder="Contraseña" name="password" />
                  </Col>
                  <Col large="2" />
                  <Col large="5">
                     <Input placeholder="Confirmar contraseña" name="confirmPassword" />
                  </Col>
                  <Col large="5"></Col>
               </Grid>
               <Grid>
                  <Col large="3" offsetL="9" className="buttonModal">
                     <AppButton
                        onClick={() => {
                           save();
                        }}
                     >
                        Guardar
                     </AppButton>
                  </Col>
               </Grid>
            </form>
         </DivModal>
      </Modal>
   );
}

const DivModal = styled.div`
   .buttonModal {
      margin-top: 2em;
   }
`;
